import brandPortalMessages from "@faire/web-api/routes/brand-portal/messages";
import articlePage from "@faire/web-api/routes/support/articles/articleId";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";
export var VatIssueIA = function VatIssueIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "41zbB/",
    defaultMessage: [{
      "type": 0,
      "value": "Voor een bestelling die over de grens binnen de EU wordt verzonden, brengt Faire btw in rekening bij het afrekenen, op basis van het land van bestemming. Als de retailer geen btw-nummer heeft opgegeven, kun je de volgende stappen nemen:"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "N1WrAx",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Een bericht sturen naar de retailer:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "vd648L",
    defaultMessage: [{
      "type": 0,
      "value": "Gebruik "
    }, {
      "children": [{
        "type": 0,
        "value": "Faire Messenger"
      }],
      "type": 8,
      "value": "ButtonFormatting"
    }, {
      "type": 0,
      "value": " om rechtstreeks contact op te nemen met de retailer om te vragen of de retailer een btw-nummer heeft dat is geregistreerd voor intracommunautaire handel. Als de retailer bevestigt dat hij of zij een btw-nummer heeft voor intracommunautaire handel, vraag hem of haar dan om zijn of haar btw-nummer toe te voegen aan zijn of haar eigen accountinstellingen op Faire. Op die manier kan de juiste btw-behandeling toegepast worden. Voor nog niet verwerkte bestellingen van EU-merken zou dit moeten resulteren in 0% btw."
    }],
    values: {
      ButtonFormatting: function ButtonFormatting(chunks) {
        return FaireMessagingFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "LokvZV",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Verwerking uitstellen:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "eFvj9E",
    defaultMessage: [{
      "type": 0,
      "value": "Overweeg om het verzenden van de bestelling uit te stellen totdat de retailer de mogelijkheid heeft om zijn of haar btw-nummer aan zijn of haar account toe te voegen. Ga voor meer uitgebreide richtlijnen naar "
    }, {
      "children": [{
        "type": 0,
        "value": "Hoe werkt btw voor bestellingen uit de EU"
      }],
      "type": 8,
      "value": "LinkFormatting"
    }, {
      "type": 0,
      "value": "?"
    }],
    values: {
      LinkFormatting: function LinkFormatting(chunks) {
        return HCFormatting(chunks);
      }
    }
  })))));
};
var FaireMessagingFormatting = function FaireMessagingFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalMessages(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var HCFormatting = function HCFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: articlePage("360057747911"),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};